module.exports = __webpack_public_path__ + "img/1510240324.4cd73b11.jpg";